import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class TraceReportDetails extends Vue {
  public get reportDetails() {
    return this.$store.getters.reportDetails;
  }
  public get request() {
    if (this.reportDetails) {
      if (this.reportDetails.request) {
        try {
          return JSON.parse(this.reportDetails.request);
        } catch {}
      }
    }
    return {};
  }
  public get response() {
    if (this.reportDetails) {
      if (this.reportDetails.response) {
        try {
          return JSON.parse(this.reportDetails.response);
        } catch {}
      }
    }
    return {};
  }
  public get originalRequest() {
    if (this.reportDetails) {
      if (this.reportDetails.originalRequest) {
        return this.reportDetails.originalRequest;
      }
    }
    return '';
  }
  public get report() {
    if (this.reportDetails) {
      if (this.reportDetails.report) {
        return this.reportDetails.report;
      }
    }
    return '';
  }
}
